import { render } from "./VolunteerModal.vue?vue&type=template&id=38b020d5"
import script from "./VolunteerModal.vue?vue&type=script&lang=js"
export * from "./VolunteerModal.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__